var _style, _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefender3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 74.2 51.4",
    style: {
      enableBackground: "new 0 0 74.2 51.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2770B8;}\n\t.st1{fill:#105193;}\n\t.st2{fill:#3180C3;}\n\t.st3{fill:#39BFEF;}\n\t.st4{fill:#2D5F59;}\n\t.st5{fill:#408F87;}\n\t.st6{fill:#397B74;}\n\t.st7{fill:#55BBB0;}\n\t.st8{enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.1,35.7c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8V35.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.8,34.9c0,0.4-0.3,0.8-0.8,0.8v-1.4C38.5,34.1,38.8,34.5,38.8,34.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 51.3,
    cy: 11.4,
    r: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 24.9,
    cy: 11.4,
    r: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.1,34.9l0.3,0.7c0,0,11.2-5.8,13.3-14.7H38.1V34.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.1,11.4l-0.8-0.7c-8.2,0-8.3-4.4-13.2-4.4v14.7h13.6c0.3-0.9,0.3-2,0.3-3C52.1,15.7,52.1,11.4,52.1,11.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.1,34.9l-0.3,0.7c0,0-11.2-5.8-13.3-14.7h13.6V34.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M24.1,11.4l0.8-0.7c8.2,0,8.3-4.4,13.2-4.4v14.7H24.4c-0.3-0.9-0.3-2-0.3-3C24.1,15.7,24.1,11.4,24.1,11.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M18.1,38.1c0.5-0.1,1.3-0.2,2-0.2c1.3,0,2.2,0.3,2.8,0.8c0.7,0.5,1.1,1.4,1.1,2.6c0,1.2-0.4,2.1-1.1,2.7 S21.2,45,19.8,45c-0.8,0-1.3,0-1.7-0.1C18.1,44.9,18.1,38.1,18.1,38.1z M19.3,44c0.2,0,0.4,0,0.7,0c1.6,0,2.6-0.9,2.6-2.6 c0-1.5-0.9-2.4-2.5-2.4c-0.4,0-0.7,0-0.9,0.1V44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.9,42.8c0,0.9,0.8,1.3,1.5,1.3c0.6,0,1-0.1,1.4-0.3l0.2,0.9c-0.4,0.2-1,0.3-1.7,0.3c-1.6,0-2.6-1-2.6-2.6 c0-1.4,0.9-2.6,2.5-2.6s2.1,1.4,2.1,2.4c0,0.3,0,0.4,0,0.5L25.9,42.8L25.9,42.8z M28.1,41.9c0-0.4-0.2-1.2-1-1.2 c-0.8,0-1.1,0.7-1.2,1.2H28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.5,45v-4h-0.7V40h0.7v-0.3c0-0.7,0.2-1.3,0.6-1.7c0.3-0.3,0.9-0.5,1.3-0.5c0.3,0,0.6,0.1,0.8,0.1L33,38.6 c-0.2-0.1-0.3-0.1-0.5-0.1c-0.6,0-0.9,0.5-0.9,1.1v0.3h1.1v0.9h-1.1v4h-1.2V45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M34.3,42.8c0,0.9,0.8,1.3,1.5,1.3c0.6,0,1-0.1,1.4-0.3l0.2,0.9c-0.4,0.2-1,0.3-1.7,0.3c-1.6,0-2.6-1-2.6-2.6 c0-1.4,0.9-2.6,2.5-2.6s2.1,1.4,2.1,2.4c0,0.3,0,0.4,0,0.5L34.3,42.8L34.3,42.8z M36.5,41.9c0-0.4-0.2-1.2-1-1.2 c-0.8,0-1.1,0.7-1.2,1.2H36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M38.8,41.5c0-0.6,0-1,0-1.4h1.1l0.1,0.8l0,0c0.3-0.4,0.8-0.9,1.6-0.9c0.9,0,1.8,0.6,1.8,2.1v3h-1.3v-2.8 c0-0.7-0.3-1.3-0.9-1.3c-0.5,0-0.9,0.3-1,0.8c0,0.1-0.1,0.3-0.1,0.4V45h-1.3V41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.2,37.7v5.9c0,0.5,0,1,0,1.4H48L48,44.2l0,0c-0.3,0.5-0.9,0.9-1.6,0.9c-1.2,0-2.1-1-2.1-2.6 c0-1.7,1-2.6,2.2-2.6c0.7,0,1.2,0.3,1.4,0.7l0,0v-2.8L49.2,37.7L49.2,37.7z M47.9,42.1c0-0.1,0-0.3,0-0.3c-0.1-0.5-0.5-0.9-1.1-0.9 c-0.8,0-1.3,0.7-1.3,1.6c0,0.9,0.4,1.5,1.3,1.5c0.5,0,0.9-0.3,1.1-0.9c0-0.1,0-0.3,0-0.3V42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51.5,42.8c0,0.9,0.8,1.3,1.5,1.3c0.6,0,1-0.1,1.4-0.3l0.2,0.9c-0.4,0.2-1,0.3-1.7,0.3c-1.6,0-2.6-1-2.6-2.6 c0-1.4,0.9-2.6,2.5-2.6s2.1,1.4,2.1,2.4c0,0.3,0,0.4,0,0.5L51.5,42.8L51.5,42.8z M53.6,41.9c0-0.4-0.2-1.2-1-1.2 c-0.8,0-1.1,0.7-1.2,1.2H53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M55.8,41.6c0-0.7,0-1.2,0-1.6h1.1v0.9l0,0c0.3-0.7,0.9-1,1.4-1c0.1,0,0.2,0,0.3,0V41c-0.1,0-0.3,0-0.3,0 c-0.6,0-1,0.4-1.1,0.9c0,0.1,0,0.3,0,0.4V45h-1.3C55.8,45,55.8,41.6,55.8,41.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefender3);
export default __webpack_public_path__ + "static/media/Defender3.6ca763006294538a0b84ded9147e1a9f.svg";
export { ForwardRef as ReactComponent };